export function clone (data) {
  return JSON.parse(JSON.stringify(data))
}

export async function timeout (ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}
